<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: "App",
};
</script>

<style>
#app {
  width: 100%;
  min-height: 100vh;
  background-color: #f1f1f1;
}
</style>
